import { fromJS } from 'immutable';

export default {
    initProjects: (state, projects) => {
        return state.setIn(['list'], fromJS(projects)).set('initialized', true);
    },
    setProjects: (state, projects) => {
        return state.mergeIn(['list'], fromJS(projects));
    },
    setProjectDetails: (state, project) => {
        return state.mergeIn(['list'], fromJS(project));
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/Projects/core.js